import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import { useNavigate } from "react-router-dom";

const AddTemplate = () => {
    const navigate = useNavigate();
    const [groupList, setGroupList] = useState([]);
    const [subGroupList, setSubGroupList] = useState([]);
    const [catalogList, setCatalogList] = useState([]);
    const [htmlDocList, setHtmlDocList] = useState([]);
    const [htmlDocZipList, setHtmlDocZipList] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState("");
    const [selectedSubGroupId, setSelectedSubGroupId] = useState("");
    const [selectedCatalogId, setSelectedCatalogId] = useState("");
    const [selectedHtmlDocId, setSelectedHtmlDocId] = useState("");
    const [selectedHtmlDocZipId, setSelectedHtmlDocZipId] = useState("");
    const [message, setMessage] = useState("");

    // Function to get cookie by name
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null; // Return null if cookie not found
    };

    const token = getCookie("token");
    const userid = getCookie("userid");

    useEffect(() => {
        const fetchOnLoadData = async () => {
            // Fetch Groups
            try {
                const groupResponse = await axios.get(
                    'https://api.dqr-display-tms.eventum.co.in/api/GroupOperation/SubUser/GetDistinct/name',
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid ,
                            'X-Authorization': token,
                        }
                    }
                );

                if (groupResponse.data && groupResponse.data.isresponse) {
                    setGroupList(groupResponse.data.data);
                }
            } catch (error) {
                console.error("Error fetching distinct group names:", error);
            }

            // Fetch Catalogs
            try {
                const catalogResponse = await axios.get(
                    'https://api.dqr-display-tms.eventum.co.in/api/CatalogOperation/SubUser/GetDistinct/catalogname',
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid ,
                            'X-Authorization': token,
                        }
                    }
                );

                if (catalogResponse.data && catalogResponse.data.isresponse) {
                    setCatalogList(catalogResponse.data.data);
                }
            } catch (error) {
                console.error("Error fetching distinct Catalogue names:", error);
            }

            // Fetch HTML Documents
            try {
                const htmlDocResponse = await axios.get(
                    'https://api.dqr-display-tms.eventum.co.in/api/HtmlDocOperation/SubUser/GetDistinct/name',
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid ,
                            'X-Authorization': token,
                        }
                    }
                );

                if (htmlDocResponse.data && htmlDocResponse.data.isresponse) {
                    setHtmlDocList(htmlDocResponse.data.data);
                }
            } catch (error) {
                console.error("Error fetching distinct HTML document names:", error);
            }

            // Fetch HTML Doc Zip Names
            try {
                const htmlDocZipResponse = await axios.get(
                    'https://api.dqr-display-tms.eventum.co.in/api/HtmlDocZipOperation/SubUser/GetDistinct/name',
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid ,
                            'X-Authorization': token,
                        }
                    }
                );

                if (htmlDocZipResponse.data && htmlDocZipResponse.data.isresponse) {
                    setHtmlDocZipList(htmlDocZipResponse.data.data);
                }
            } catch (error) {
                console.error("Error fetching distinct HTML Doc Zip names:", error);
            }
        };

        fetchOnLoadData();
    }, [token, userid]);

    const handleGroupChange = async (e) => {
        const groupId = e.target.value;
        setSelectedGroupId(groupId);
        setSelectedSubGroupId(""); // Reset subgroup selection
        setSubGroupList([]); // Clear previous subgroups

        if (groupId) {
            try {
                const response = await axios.get(
                    `https://api.dqr-display-tms.eventum.co.in/api/SubGroupOperation/SubUser/GetDistinct/name/${groupId}`,
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid ,
                            'X-Authorization': token,
                        }
                    }
                );

                if (response.data && response.data.isresponse) {
                    setSubGroupList(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching distinct sub-group names:", error);
            }
        }
    };

    const handleSubmit = async () => {
        try {
            const data = {
                subgroupid: Number(selectedSubGroupId) || -1,
                groupid: Number(selectedGroupId) || -1,
                catalogid: Number(selectedCatalogId) || -1,
                htmldocid: Number(selectedHtmlDocId) || -1,
                htmldoczipid: Number(selectedHtmlDocZipId) || -1
            };

            const response = await axios.post(
                'https://api.dqr-display-tms.eventum.co.in/api/DefaultTemplateOperation/SubUser/Insert',
                data,
                {
                    headers: {
                        'accept': 'text/plain',
                        'UserId': userid ,
                        'X-Authorization': token,
                        'Content-Type': 'application/json-patch+json'
                    }
                }
            );

            if (response.data && response.data.isresponse) {
                setMessage("Template added successfully!");
                setTimeout(() => {
                    navigate("/default-template");
                }, 2000);
            } else {
                setMessage(response.data.errormsg || "Failed to add template.");
            }
        } catch (error) {
            console.error("Error inserting template:", error);
            setMessage("Error submitting data.");
        }
    };

    return (
        <>
            <Menu />
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>Add Template</h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card card-info">
                                        <div className="card-header">
                                            <h3 className="card-title">Selection Form</h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Group Name</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedGroupId}
                                                            onChange={handleGroupChange}
                                                        >
                                                            <option value="">-- Select Group --</option>
                                                            <option value="-1">All</option>
                                                            {groupList && groupList.length > 0 && groupList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Sub Group Name</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedSubGroupId}
                                                            onChange={(e) => setSelectedSubGroupId(e.target.value)}
                                                            disabled={!selectedGroupId}
                                                        >
                                                            <option value="">-- Select Sub Group --</option>
                                                            <option value="-1">All</option>
                                                            {subGroupList && subGroupList.length > 0 && subGroupList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Catalogue Name</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedCatalogId}
                                                            onChange={(e) => setSelectedCatalogId(e.target.value)}
                                                        >
                                                            <option value="">-- Select Catalogue --</option>
                                                            <option value="-1">null</option>
                                                            {catalogList && catalogList.length > 0 && catalogList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>HTML Document Name</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedHtmlDocId}
                                                            onChange={(e) => setSelectedHtmlDocId(e.target.value)}
                                                        >
                                                            <option value="">-- Select HTML Document --</option>
                                                            <option value="-1">null</option>
                                                            {htmlDocList && htmlDocList.length > 0 && htmlDocList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>HTML Doc Zip Name</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedHtmlDocZipId}
                                                            onChange={(e) => setSelectedHtmlDocZipId(e.target.value)}
                                                        >
                                                            <option value="">-- Select HTML Doc Zip --</option>
                                                            <option value="-1">null</option>
                                                            {htmlDocZipList && htmlDocZipList.length > 0 && htmlDocZipList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button type="button" className="btn btn-info" onClick={handleSubmit}>Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {message === "Template added successfully!" && (
                <SuccessMessage message={message} />
            )}

            {message && message !== "Template added successfully!" && (
                <FailedMessage message={message} />
            )}
        </>
    );
};

export default AddTemplate;

